import { autoinject } from 'aurelia-framework';
import { WidgetController } from 'controls/as-widget-container';
import { WidgetBase } from 'support/base_classes/widget-base';
import { EmailAddressWrapper } from 'model/support-types';
import { ValidationRules } from 'aurelia-validation';

@autoinject
export class AdminCountryEmailWidget extends WidgetBase<EmailAddressWrapper, WidgetController> {
  constructor() {
    super();
  }

  changed() {
    ValidationRules
      .ensureObject<EmailAddressWrapper>().required()
      .ensure(model => model.emailAddress).displayName('Generic email address').required().email().withMessage('E-mail address in valid format is required.')
      .on(this.model);
  }
}
